/** Cents → "$59" / "$39.50". Null/undefined (no payment row, e.g. free-flow patients) → "$0". */
export function formatDollars(amountCents: number | null | undefined) {
  const dollars = (amountCents ?? 0) / 100

  return Number.isInteger(dollars) ? `$${dollars}` : `$${dollars.toFixed(2)}`
}
